import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onDeleteAttributeRes } from "./helper";

const deleteAttribute = async (id: number) =>
  axios.delete(Routes.DELETE_ATTRIBUTE + "/" + id);

export const useDeleteAttribute = () =>
  useMutation({
    mutationKey: [Keys.DELETE_ATTRIBUTE_MUT],
    mutationFn: deleteAttribute,
    onSuccess: onDeleteAttributeRes,
  });
